import { type OfferV11, type PimProductV11 } from '@redteclab/api/clients/bully'

export const productAccessorGetProductNameWithPromotionName = (
  currentOffer: OfferV11,
  product: PimProductV11,
): string => {
  if (!currentOffer.offerPromotion?.promotionOfferPostfix) {
    return product.name
  }

  return `${product.name} ${currentOffer.offerPromotion.promotionOfferPostfix}`
}
